import apiClient from '../apiClient';

export async function fetchIncidentReports(params = {}) {
  const searchParams = new URLSearchParams();

  if (params.startDate) {
    searchParams.set('startDate', params.startDate);
  }

  if (params.endDate) {
    searchParams.set('endDate', params.endDate);
  }

  const query = searchParams.toString();
  const response = await apiClient.get(`/incident-reports${query ? `?${query}` : ''}`);
  return response.data ?? [];
}

export async function createIncidentReport(payload) {
  const response = await apiClient.post('/incident-reports', payload);
  return response.data;
}

export async function updateIncidentReport(id, payload) {
  if (!id) {
    throw new Error('Incident id is required to update a report');
  }
  const response = await apiClient.patch(`/incident-reports/${id}`, payload);
  return response.data;
}

export async function deleteIncidentReport(id) {
  if (!id) {
    throw new Error('Incident id is required to delete a report');
  }
  const response = await apiClient.delete(`/incident-reports/${id}`);
  return response.data;
}
